/* eslint-disable no-console */
import { Socket, io } from 'socket.io-client';
import { locale } from '../i18n';
import store from '../store';

let ws: Socket | undefined;

export const closeSocket = () => async () => {
  ws?.close();
  ws = undefined;
};

export const emitTranslationInfo = ({
  token,
  translate,
}: { token?: string; translate?: boolean } = {}) => {
  const state = store.getState();

  const oprSessionToken = state.openReporting.openReportingReducer.session;
  const resHubSessionToken = state.globalUsers.session;

  const finalToken = token || oprSessionToken || resHubSessionToken;

  if (!finalToken) {
    return;
  }

  ws?.emit('setTranslationInfo', {
    language: locale,
    translate:
      translate ??
      state.openReporting.openReportingReducer.translateMessages ??
      false,
    token: finalToken,
  });
};

export const createSocket = (token: string, clearSessionFn: () => void) => {
  const translateState =
    store.getState().openReporting.openReportingReducer.translateMessages;

  if (ws !== undefined) {
    if (!ws.connected) {
      ws.connect();
    }
    ws.io.opts.query = {
      translate: translateState,
      language: locale,
    };
    return ws;
  }

  ws = io(`/?translate=${translateState}&language=${locale}`, {
    transports: ['websocket'],
  });

  ws.on('disconnect', (reason: string) => {
    if (reason === 'io server disconnect') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      store.dispatch(clearSessionFn() as any);
    }
  });

  ws.on('reconnect', () => {
    if (ws) {
      // Reconnect with the updated query parameters
      ws.io.opts.query = {
        translate: translateState,
        language: locale,
      };

      emitTranslationInfo({ token, translate: translateState });
      ws.emit('join', { token });
    }
  });

  emitTranslationInfo({ token });

  return ws;
};
